import { Middleware } from '@reduxjs/toolkit';
import i18n from 'i18next';

import {
  initiateNewTransaction,
  setPaymentResult,
  updatePaymentFormPayloadItem,
} from '@cashier/cashier-data-access';
import {
  FinalStates,
  ResultMessage,
  ValidationStatuses,
} from '@cashier/cashier-model';
import { eventBus, EventFactory } from '@cashier/cashier-shared';

export const parentNotificationMiddleware: Middleware =
  (store) => (next) => (action) => {
    const {
      cashierConfiguration: { notifyCustomerAboutPaymentResult },
    } = store.getState();

    const result = next(action);

    if (
      action.type === setPaymentResult.toString() &&
      notifyCustomerAboutPaymentResult
    ) {
      const paymentResult: {
        finalState: FinalStates;
        message: ResultMessage;
      } = action.payload;

      //@TODO: Crutch for pending state
      const message =
        FinalStates.PENDING === paymentResult.finalState
          ? paymentResult.message
            ? `${i18n.t('finalScreenPending.text1')} ${paymentResult.message.content}`
            : i18n.t('finalScreenPending.text1')
          : paymentResult.message.content;

      eventBus.emit(
        EventFactory.cashierClosed(paymentResult.finalState, message),
      );
    }

    if (action.type === initiateNewTransaction.toString()) {
      const {
        paymentResult: { finalState },
        paymentProcessing: { error },
        paymentSnapshot: { amount },
      } = store.getState();

      if (FinalStates.ERROR === finalState) {
        eventBus.emit(
          EventFactory.paymentRetried(amount ?? '0', error?.transactionId),
        );
      } else {
        eventBus.emit(EventFactory.newPaymentInitiated());
      }
    }

    if (action.type === updatePaymentFormPayloadItem.toString()) {
      const { name, fieldPayload } = action.payload;

      if (
        fieldPayload.interactionCompleted &&
        fieldPayload.validationStatus === ValidationStatuses.FAILED
      ) {
        eventBus.emit(
          EventFactory.onValidationFailed(name, fieldPayload.errors.join(' ')),
        );
      }
    }

    return result;
  };
